// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"125b012e","455":"5c05873e"}[chunkId] + ".chunk.js";
};